import { Injectable, inject } from '@angular/core';
import { SettingsService } from './settings.service';
import { NetworkConstants } from 'na-lib';
import { Firestore, collection, deleteDoc, deleteField, doc, setDoc, updateDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  private db = inject(Firestore);
  constructor(private settingsService: SettingsService) { }


  async createContent(newContent:any):Promise<string>{
    return new Promise(async (resolve, reject) => {
      const ref = doc(collection(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_CONTENT));
      const newId = ref.id

      newContent['creationDate'] = new Date()
      newContent['timeStamp'] = new Date()
      newContent['id'] = newId

      try{
        await setDoc(ref, newContent );
        resolve(newId)
      }catch(error){
        reject(error)
      }
    })  

  }


  updateContent(contentId:string, data:any):Promise<void>{
    return new Promise(async (resolve, reject) => {
      try{
        data['timeStamp']= new Date()

        for (const key in data) {
          const value = data[key];
          // delete empty value and values field
          if (value === "") {
            data[key] = deleteField();
          }
          else if (key === 'values' && typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const cleanedValues: any = {};
            for (const subKey in value) {
              if (value[subKey] !== "") {
                cleanedValues[subKey] = value[subKey];
              }
            }
            data[key] = Object.keys(cleanedValues).length > 0 ? cleanedValues : deleteField();
          }
          if(key == "values" && Object.keys(value)?.length==0)
            data[key] = deleteField();
        }

        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_CONTENT, contentId)
        await updateDoc( docRef, data );

        resolve()
      }catch(error){
        reject(error)
      }
    }) 
  }

  deletecontent(contentId):Promise<void>{
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_CONTENT, contentId)
        const d  = await deleteDoc( docRef)
        resolve(d)
      } catch (error) {
        reject(error)  
        console.log(error)      
      } 
    })
  }

}
